import { createContext, useContext } from 'react';
import type { SharedValue } from 'react-native-reanimated';

/**
 * Shared vertical scroll offset of the landing ScrollView, published on the UI
 * thread so any descendant can drive parallax / reveal animations from it.
 */
export interface ScrollState {
  offset: SharedValue<number>;
}

export const ScrollContext = createContext<ScrollState | null>(null);

/** Returns the scroll state, or null when rendered outside a ParallaxScrollView. */
export const useScrollState = (): ScrollState | null => useContext(ScrollContext);
